import styled from 'styled-components'

export default styled.article`
  display: flex;
  height: 100%;
  width: 100vw;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px;
  box-sizing: border-box;

  .form-wrapper {
    width: 515px;
    flex: 1;
    border-radius: 20px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    padding: 70px 90px;
    box-sizing: border-box;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    background-color: ${ ({ theme }) => theme.colors.white };
    position: relative;
    
    header {
      flex: 0;
      margin-bottom: 25px;
      align-items: center;
      text-align: center;
  
      img.logoAmb {
        max-width: 365px;
      }
      
      img.logoNemiRounded {
        max-width: 100px;
        margin-bottom: 50px;
      }
    }
    
    .error-container {
      display: flex;
      flex-direction: row;
      margin-bottom: 25px;
      text-align: center;
      align-items: center;
      .error-message {
        color: ${ ({ theme }) => theme.colors.red };
      }
    }

    .actions {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 16px;

      .backButton {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 4px;
        color: ${ ({ theme }) => theme.colors.greyDark };
        cursor: pointer;

        img {
          width: 16px;
          height: 16px;
          display: block;
          cursor: pointer;
          filter: brightness(0) saturate(100%) invert(32%) sepia(5%) saturate(165%) hue-rotate(202deg) brightness(99%) contrast(85%);
        }
      }
    }
  }
`